import { useEffect, useState } from 'react';

// True on touch-first devices (phones/tablets) and narrow viewports. Hover
// affordances don't work there (no hover / stacked layout), so interactive
// overlays must stay permanently visible and selections scroll into view.
export const useIsTouch = (): boolean => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse), (max-width: 1023px)');
    setIsTouch(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setIsTouch(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isTouch;
};
